// extracted by mini-css-extract-plugin
export default {"outlet":"settings_outlet__e4gP6","title":"settings_title__-1vsD","preferences":"settings_preferences__idsxW"};